import Vue from 'vue';
import store from '../store/index';
// 权限按钮指令
Vue.directive('has', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el:any, binding) {
      const role = store.getters.role
      const value = binding.value;
      if(!value.includes(role)) el.style.display = "none";
    }
  })